// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';


import DataTest from '@/views/charts/dataTest';


// 引入状态管理
import store from '@/vuex/store'

//数据监控-- 实时数据
import RealTime from '@/views/datamonitoring/realTime';

//数据监控-- 抄表数据
import MeterData from '@/views/datamonitoring/meterData';

//数据监控-- 用能数据
import EnergyData from '@/views/datamonitoring/energyData';


//档案管理 -- 企业信息
import EnterpriseInformation from '@/views/archives/enterpriseInformation';

//档案管理 -- 用能结构
import Structure from '@/views/archives/structure';

//档案管理 -- 终端维护
import Wiehu from '@/views/archives/weihu';

//档案管理 -- 平衡公式
import GongShi from '@/views/archives/gongshi';

//档案管理 -- 告警参数
import Gaojing from '@/views/archives/gaojing';

//档案管理 -- 能源分项
import EnergyType from '@/views/archives/energyType';

//档案管理 -- 采集方案
import CollectionScheme from '@/views/archives/collectionScheme';

//档案管理 -- windows数据查询
import WindowsData from '@/views/archives/windowsData.vue';


/**
 * 系统管理
 */
// 用户管理
import User from '@/views/system/user';
// 菜单管理
import Module from '@/views/system/Module';
// 角色管理
import Role from '@/views/system/Role';
// 公司管理
import Group from '@/views/system/UserGroup';

// 权限管理
import Permission from '@/views/system/Permission';



//地图管理
import MapSet from '@/views/system/MapSet.vue';



/**
 * 优质用电
 */

// 功率因素
import Yingsu from '@/views/yongdian/yinsu';

// 负载率
import FuZai from '@/views/yongdian/fuzailv';

// 曲线分析
import QuXian from '@/views/yongdian/quxianfx';

// 三相不平衡
import SanXian from '@/views/yongdian/sanxianbph';

// 电平衡分析
import DianPinH from '@/views/yongdian/dianpinghengfx';

// 告警查询
import GaoJing from '@/views/yongdian/gaojingcx';




/**
 * 远程预付费
 */

import ElectricRule from '@/views/prepayment/electricRule';

import WaterRule from '@/views/prepayment/waterRule';

//远程预付费 -- 支付管理
import Pay from '@/views/prepayment/pay';

//远程预付费 -- 终端用户管理
import Cuser from '@/views/prepayment/cuser';

//远程预付费 -- 房间管理
import Room from '@/views/prepayment/room';

//远程预付费 -- 操作记录
import Operation from '@/views/prepayment/operation';

//远程预付费 -- 月账单
import Bill from '@/views/prepayment/bill';

import Bank from '@/views/prepayment/bank';

import BankInfo from '@/views/prepayment/bankInfo.vue'




//远程预付费 -- 开户管理
import OpenAccount from '@/views/prepayment/openAccount';

//远程预付费 --尖峰平谷设置
import Jrule from '@/views/prepayment/jrule';


import UnitSet from '@/views/property/unit';

import Rent from '@/views/property/rent';

import Contract from '@/views/property/contract';


import BillSet from '@/views/property/billset';



// 图表界面
import statistics from '@/views/charts/statistics';

// 图表界面
import HomeTest from '@/views/charts/homeTest';


//非预付费首页
import NoPrepayment from '@/views/charts/noPrepayment';

//非预付费首页
import Property from '@/views/property/Property';


/**
 * 能耗分析
 */
//分级分项统计
import CategoryStatistics from '@/views/analysis/categoryStatistics';

import ChaoBiao from '@/views/analysis/chaoBiao.vue';


//分级分时统计
import TimeStatistics from '@/views/analysis/timeStatistics';

//分类分时统计
import TypeStatistics from '@/views/analysis/typeStatistics';

//横向对比分析
import HorizontalData from '@/views/analysis/horizontalData.vue';

//纵向对比分析
import VerticalData from '@/views/analysis/verticalData.vue';

//同期对比分析
import TimeData from '@/views/analysis/timeData.vue';

import FuHe from '@/views/analysis/fuHe.vue';


import XianSun from '@/views/analysis/xs.vue';
//同期对比分析
import WxPay from '@/views/system/wxPay.vue';

//短信
import Msg from '@/views/prepayment/Msg.vue';



import Jiesuan from '@/views/prepayment/jiesuan.vue';



import Summary from '@/views/charts/summary.vue';

import Porder from '@/views/property/Porder.vue';

import SetWater from '@/views/property/SetWater.vue';

import ZD from '@/views/property/zd.vue';

import ZRoom from '@/views/property/zRoom.vue';


import WaterManage from '@/views/property/waterManage.vue';







import SetProperty from '@/views/property/SetProperty.vue';

import MsgStatistics from '@/views/message/msgStatistics.vue';

import MsgSet from '@/views/system/msgSet.vue';

import MsgList from '@/views/message/msgList.vue';



import Zcb from '@/views/archives/pc.vue';

import Area from '@/views/archives/area.vue';

import Wallet from '@/views/account/wallet.vue';

import AccountOrder from '@/views/account/accountOrder.vue';

import WalletBill from '@/views/account/walletBill.vue';

import SetGW from '@/views/archives/setgw.vue'

import DataBill from '@/views/archives/dataBill.vue';

import DataBill1 from '@/views/archives/dataBill1.vue';

import DataBill2 from '@/views/archives/dataBill2.vue';


import SwitchSet from '@/views/prepayment/switchSet.vue';

import MessageSet from '@/views/prepayment/messageSet.vue';

import FsRule from '@/views/prepayment/fsRule.vue';

import FsBill from '@/views/prepayment/fsBill.vue';

import FsDetaile from '@/views/prepayment/fsDetaile.vue';

import FsProcess from '@/views/prepayment/fsProcess.vue';

import FsPz from '@/views/prepayment/fsPz.vue';

//档案管理 -- 用能结构新加
import Structure00 from '@/views/archives/structure00';
// 2023.11.20 预警阀值
import alarmValue from '@/views/alarmManager/alarmValue'
// 2023.11.21 预警记录
import alarmRecorde from '@/views/alarmManager/alarmRecorde'
// 2023.11.22 群聊信息管理
import groupChatMessage from '@/views/alarmManager/groupChatMessage'
import editEsData from '@/views/archives/editEsData'

// 启用路由
Vue.use(Router);


// 导出路由

const router = new Router({
  // mode: 'history',
  routes: [{
    path: '/',
    name: '',
    component: login,
    hidden: true,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/login',
    name: '登录',
    component: login,
    hidden: true,
    meta: {
      requireAuth: false
    }
  }, {
    path: '/index',
    name: '首页',
    component: index,
    iconCls: 'el-icon-tickets',
    children: [{
        path: '/datamonitoring/RealTime',
        name: '实时数据',
        component: RealTime,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/system/dataTest',
        name: '数据测试',
        component: DataTest,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/home/Test',
        name: '首页测试',
        component: HomeTest,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/datamonitoring/meterData',
        name: '抄表数据',
        component: MeterData,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/datamonitoring/EnergyData',
        name: '用能数据',
        component: EnergyData,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/archives/eInfo',
        name: '企业信息',
        component: EnterpriseInformation,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/archives/structure',
        name: '用能结构',
        component: Structure00,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/archives/wiehu',
        name: '终端维护',
        component: Wiehu,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/archives/dataBill',
        name: '账单数据',
        component: DataBill,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/archives/dataBill1',
        name: '账单数据1',
        component: DataBill1,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/archives/dataBill2',
        name: '账单数据2',
        component: DataBill2,
        meta: {
          requireAuth: true
        }
      },

      {
        path: '/archives/energyType',
        name: '能源分项管理',
        component: EnergyType,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/archives/area',
        name: '线损区域管理',
        component: Area,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/archives/pc',
        name: '从属表管理',
        component: Zcb,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/archives/windowsData',
        name: 'windows数据查询',
        component: WindowsData,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/archives/gongshi',
        name: '平衡公式',
        component: GongShi,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/archives/setgw',
        name: '国网下发配置规则',
        component: SetGW,
        meta: {
          requireAuth: true
        }
      },

      {
        path: '/archives/gaojing',
        name: '告警参数',
        component: Gaojing,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/archives/collectionScheme',
        name: '采集方案',
        component: CollectionScheme,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/prepayment/order',
        name: '支付管理',
        component: Pay,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/prepayment/bankInfo',
        name: '银行账号管理',
        component: BankInfo,
        meta: {
          requireAuth: true
        }
      },

      {
        path: '/prepayment/cuser',
        name: '终端用户管理',
        component: Cuser,
        meta: {
          requireAuth: true
        }
      },
       {
        path: '/prepayment/jiesuan',
        name: '提前结算',
        component: Jiesuan,
        meta: {
          requireAuth: true
        }
      },

      {
        path: '/prepayment/room',
        name: '房间管理',
        component: Room,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/prepayment/zRoom',
        name: '租房管理',
        component: ZRoom,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/property/unit',
        name: '单元管理',
        component: UnitSet,
        meta: {
          requireAuth: true
        }
      },

      {
        path: '/property/rent',
        name: '租金管理',
        component: Rent,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/property/bank',
        name: '银行分账管理',
        component: Bank,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/property/zd',
        name: '账单管理',
        component: ZD,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/property/billset',
        name: '账单配置',
        component: BillSet,
        meta: {
          requireAuth: true
        }
      },


      {
        path: '/property/contract',
        name: '合同管理',
        component: Contract,
        meta: {
          requireAuth: true
        }
      },

      {
        path: '/prepayment/electricRule',
        name: '电价规则',
        component: ElectricRule,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/prepayment/waterRule',
        name: '水价规则',
        component: WaterRule,
        meta: {
          requireAuth: true
        }
      },

      {
        path: '/prepayment/fsRule',
        name: '反算电价规则',
        component: FsRule,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/prepayment/fsBill',
        name: '反算月账单',
        component: FsBill,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/prepayment/fsDetaile',
        name: '反算明细',
        component: FsDetaile,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/prepayment/fsProcess',
        name: '反算过程',
        component: FsProcess,
        meta: {
          requireAuth: true
        }
      },

      {
        path: '/prepayment/operation',
        name: '操作记录',
        component: Operation,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/prepayment/bill',
        name: '月账单',
        component: Bill,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/prepayment/jurle',
        name: '尖谷平谷设置',
        component: Jrule,
        meta: {
          requireAuth: true
        }
      },

      {
        path: '/prepayment/switchSet',
        name: '拉合闸设置',
        component: SwitchSet,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/prepayment/messageSet',
        name: '终端用户短信规则',
        component: MessageSet,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/prepayment/openAccount',
        name: '开户管理',
        component: OpenAccount,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/system/Module',
        name: '菜单管理',
        component: Module,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/system/wxPay',
        name: '微信支付配置管理',
        component: WxPay,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/prepayment/msg',
        name: '短信管理',
        component: Msg,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/system/Role',
        name: '角色管理',
        component: Role,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/system/user',
        name: '用户管理',
        component: User,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/system/userGroup',
        name: '用户组管理',
        component: Group,
        meat: {
          requireAuth: true
        }
      },

      {
        path: '/system/Permission',
        name: '权限管理',
        component: Permission,
        meta: {
          requireAuth: true
        }
      },


      {
        path: '/charts/statistics',
        name: '数据分析',
        component: statistics,
        meta: {
          requireAuth: true
        }
      },

      {
        path: '/charts/noPrepayment',
        name: '数据统计',
        component: NoPrepayment,
        meta: {
          requireAuth: true
        }
      },

      {
        path: '/system/yingsu',
        name: '功率因素',
        component: Yingsu,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/system/fuzai',
        name: '负载率',
        component: FuZai,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/system/QuXian',
        name: '曲线分析',
        component: QuXian,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/system/sanxiang',
        name: '三相不平衡',
        component: SanXian,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/system/dianp',
        name: '电平衡分析',
        component: DianPinH,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/system/gaojing',
        name: '告警查询',
        component: GaoJing,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/analysis/categoryStatistics',
        name: '分级分项统计',
        component: CategoryStatistics,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/analysis/chaobiao',
        name: '分级分项统计',
        component: ChaoBiao,
        meta: {
          requireAuth: true
        }
      },

      {
        path: '/analysis/timeStatistics',
        name: '分级分时统计',
        component: TimeStatistics,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/analysis/typeStatistics',
        name: '分类分时统计',
        component: TypeStatistics,
        meta: {
          requireAuth: true
        }
      },

      {
        path: '/analysis/horizontalData',
        name: '横向对比分析',
        component: HorizontalData,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/analysis/verticalData',
        name: '纵向对比分析',
        component: VerticalData,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/analysis/timeData',
        name: '同期对比分析',
        component: TimeData,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/analysis/xs',
        name: '线损分析',
        component: XianSun,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/analysis/fuhe',
        name: '负荷曲线',
        component: FuHe,
        meta: {
          requireAuth: true
        }
      },
      {
        path: '/charts/summary',
        name: '数据汇总',
        component: Summary,
        meta: {
          requireAuth: true
        }
      },
	   {
        path: '/property/property',
        name: '物业统计',
        component: Property,
        meta: {
          requireAuth: true
        }
      },

      {
         path: '/property/porder',
         name: '交易记录',
         component: Porder,
         meta: {
           requireAuth: true
         }
       },

      {
         path: '/property/setWater',
         name: '水费设置',
         component: SetWater,
         meta: {
           requireAuth: true
         }
       },
      {
         path: '/property/setProperty',
         name: '物业费设置',
         component: SetProperty,
         meta: {
           requireAuth: true
         }
       },
       {
         path: '/property/waterManage',
         name: '物业费设置',
         component: WaterManage,
         meta: {
           requireAuth: true
         }
       },
       {
         path: '/set/mapSet',
         name: '物业费设置',
         component: MapSet,
         meta: {
           requireAuth: true
         }
       },
       {
         path: '/msg/statistics',
         name: '短信统计',
         component: MsgStatistics,
         meta: {
           requireAuth: true
         }
       },
       {
         path: '/system/msgSet',
         name: '短信合同管理',
         component: MsgSet,
         meta: {
           requireAuth: true
         }
       },
       {
         path: '/msg/msgList',
         name: '短信列表',
         component: MsgList,
         meta: {
           requireAuth: true
         }
       },
       {
         path: '/account/wallet',
         name: '钱包管理',
         component: Wallet,
         meta: {
           requireAuth: true
         }
       },
       {
         path: '/account/accountOrder',
         name: '交易记录',
         component: AccountOrder,
         meta: {
           requireAuth: true
         }
       },
      {
         path: '/account/walletBill',
         name: '钱包报表',
         component: WalletBill,
         meta: {
           requireAuth: true
         }
      },
      {
         path: '/prepayment/fsPz',
         name: '反算平账',
         component: FsPz,
         meta: {
           requireAuth: true
         }
      },
      {
         path: '/archives/structure00',
         name: '用能结构',
         component: Structure,
         meta: {
           requireAuth: true
         }
      },
      {
        path: '/alarmManager/alarmValue',
        name: '预警阀值',
        component: alarmValue,
        meta: {
          requireAuth: true
        }
     },
     {
      path: '/alarmManager/alarmRecorde',
      name: '预警记录',
      component: alarmRecorde,
      meta: {
        requireAuth: true
      }
   },
   {
    path: '/alarmManager/groupChatMessage',
    name: '群聊信息管理',
    component: groupChatMessage,
    meta: {
      requireAuth: true
    }
 },
 {
  path: '/archives/editEsData',
  name: '处理ES数据',
  component: editEsData,
  meta: {
    requireAuth: true
  }
},



    ]
  }]
})

// 路由拦截器
router.beforeEach((to, from, next) => {
  // if(to.fullPath.indexOf("xls") == -1){
  //
  // }
  if (to.matched.length != 0) {
    let userLogin = store.state.user // 通过vuex state获取当前的user是否存在

    if (!userLogin) {
      userLogin = sessionStorage.getItem("userInfo");
    }
    if (to.meta.requireAuth) { // 判断该路由是否需要登录权限

      if (userLogin) {

        next();
      } else {

        next({
          path: '/login',
          query: {
            redirect: to.fullPath
          } // 将跳转的路由path作为参数，登录成功后跳转到该路由
        })
      }
    } else {
      if (userLogin) { // 判断是否登录

        if (to.path != "/" && to.path != "/login") { //判断是否要跳到登录界面
          next();
        } else {
          /**
           * 防刷新，如果登录，修改路由跳转到登录页面，修改路由为登录后的首页
           */
          next({
            path: '/charts/statistics'
          })
        }
      } else {
        next();
      }
    }
  } else {
    next({
      path: '/login',
      query: {
        redirect: to.fullPath
      } // 将跳转的路由path作为参数，登录成功后跳转到该路由
    })
  }
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js